import { post } from '../../axios/post'
import { store } from 'src/store'

function setDone (val = true) {
  store.commit('setDataloaderDone', val)
}

function checkLoaded () {
  return store.getters.getDataloaderDone
}

export default {
  async loadUserData (force = false) {
    if (!force && checkLoaded()) {
      return true
    }
    const { status, payload } = await post('v1/user/load')
    if (status === 'success') {
      if (!store.getters.isLoggedIn) {
        return false
      }

      return new Promise(resolve => {
        store.dispatch('socketNeedsUpdating').then(function () {
          store.commit('setUserData', payload.details)
          store.commit('setLastSocketUpdate', payload.socket_last_seen_at)
          store.commit('setPermissions', payload.permissions)
          store.commit('company/setCompany', (payload.company || {}))
          store.commit('company/setCompanyNewbie', { values: payload.company_newbie })
          store.commit('setNewbie', { values: (payload.newbie || []) })
          store.commit('tips/setTips', (payload.tips || []))
          store.commit('providers/addProviders', { value: payload.providers })
          store.commit('providers/setLastAccountingSync', payload.last_accounting_sync)
          store.commit('providers/setCurrentAccountingSync', payload.current_accounting_sync)
          store.commit('setSetting', { key: 'dashboardMessage', value: payload.dashboard_message })
          store.commit('setSetting', { key: 'sidebarMessage', value: payload.sidebar_message })
          store.commit('setMaintenance', payload.maintenance)
          store.commit('articles/setArticles', payload.articles)
          store.commit('setSystemSettings', payload.system_settings)

          // Fetch latest SMS pricing (business only: the endpoint is forbidden for connect users)
          if (store.getters.getPortal === process.env.SCOPES.business) {
            store.dispatch('fetchSmsPricing').catch(error => {
              console.warn('Failed to fetch SMS pricing during initialization:', error)
            })
          }

          setDone()
          resolve(true)
        })
      })
    }
    else {
      return false
    }
  },
  setDone,
  checkLoaded
}
